// @file Whether the slideshow nav shows the vertical (up/down) controls instead of the
// horizontal ones. Swipe-to-navigate reads the same value so the gesture matches the arrows.
import device from '@@/bits/device'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { storeToRefs } from 'pinia'
import { computed, type ComputedRef } from 'vue'

function useWhiteboardSlideshowVerticalNav(): ComputedRef<boolean> {
  const { isLandscapePhone } = storeToRefs(useSurfaceContainerSizeStore())
  return computed(() => device.phone && isLandscapePhone.value)
}

export { useWhiteboardSlideshowVerticalNav }
